import { render } from "./cp_hSortTag.vue?vue&type=template&id=c3f22236&scoped=true"
import script from "./cp_hSortTag.vue?vue&type=script&lang=js"
export * from "./cp_hSortTag.vue?vue&type=script&lang=js"

import "./cp_hSortTag.vue?vue&type=style&index=0&id=c3f22236&scoped=scoped&lang=less"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f22236"]])

export default __exports__